import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../utils/cn';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  className
}: SectionHeadingProps) {
  return <div className={cn('mb-12 space-y-4', align === 'center' ? 'text-center' : 'text-left', className)} data-id="element-306">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-5xl font-bold font-heading tracking-tight text-white" data-id="element-307">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className="text-muted-text text-lg max-w-2xl mx-auto" data-id="element-308">
          {subtitle}
        </motion.p>}
      <motion.div initial={{
      scaleX: 0
    }} whileInView={{
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2,
      duration: 0.8
    }} className={cn('h-1 w-24 bg-primary-blue rounded-full', align === 'center' ? 'mx-auto' : '')} data-id="element-309" />
    </div>;
}